import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PreloaderModule } from '@hdms/shared/ui-core';

import { ContactBodyLoaderService } from './contact-body-loader.service';
import { ContactBodyComponent } from './contact-body.component';

@NgModule({
  declarations: [ContactBodyComponent],
  imports: [CommonModule, PreloaderModule],
  providers: [ContactBodyLoaderService],
  exports: [ContactBodyComponent]
})
export class ContactBodyModule {}
